import React, { useEffect, useState } from 'react';
import { Row, Col, Card, CardBody, ButtonGroup, Button } from 'reactstrap';
import { WebsiteAnalyticsChart } from './ChartComponet/WebsiteAnalyticsChart';
import './dashboard.scss';
import { useSelector, useDispatch } from "react-redux";
import { fetchWebWeeklyInsightRequest } from "../../store/Dashboard/dashboardAction";

const WebsiteAnalytics = () => {
    const [chartData, setChartData] = useState({
        androidLeadData: [],
        androidAddToCartData: [],
        androidPurchaseData: [],
        iOSLeadData: [],
        iOSAddToCartData: [],
        days: [],
        iOSPurchaseData: [],
        totalLeadCount: 0,
        totalAddToCartCount: 0,
        totalPurchaseCount: 0,
    });

    const dispatch = useDispatch();
    const { data: webWeeklyInsight } = useSelector(
        (state) => state.webWeeklyInsight
    );

    useEffect(() => {
        dispatch(fetchWebWeeklyInsightRequest());
    }, [dispatch]);
    
    useEffect(() => {
        if (
            webWeeklyInsight &&
            webWeeklyInsight.androidLeadCount !== undefined &&
            webWeeklyInsight.androidAddToCartCount !== undefined &&
            webWeeklyInsight.androidPurchaseCount !== undefined
        ) {
            setChartData({
                androidLeadData: webWeeklyInsight.androidLeadCount,
                androidAddToCartData: webWeeklyInsight.androidAddToCartCount,
                androidPurchaseData: webWeeklyInsight.androidPurchaseCount,
                days: webWeeklyInsight.days,
                iOSLeadData: webWeeklyInsight.iOSLeadCount,
                iOSAddToCartData: webWeeklyInsight.iOSAddToCartCount,
                iOSPurchaseData: webWeeklyInsight.iOSPurchaseCount,
                totalLeadCount: webWeeklyInsight.totalLeadCount,
                totalAddToCartCount: webWeeklyInsight.totalAddToCartCount,
                totalPurchaseCount: webWeeklyInsight.totalPurchaseCount,
            });
        }
    }, [webWeeklyInsight]);    

    return (
        <React.Fragment>
            <Card>
                <CardBody>
                    <div className="float-end d-none d-md-inline-block">
                        <ButtonGroup className="mb-2">
                            <Button size="sm" color="light" active type="button">
                                Weekly
                            </Button>
                        </ButtonGroup>
                    </div>
                    <h4 className="card-title mb-2">Website Insights: Day by Day Report</h4>
                    <div id="line-column-chart" className="apex-charts" dir="ltr">
                        <WebsiteAnalyticsChart chartData={chartData} />
                    </div>
                </CardBody>

                <CardBody className="border-top text-center">
                    <Row>
                        <Col sm={4}>
                            <div className="d-inline-flex">
                                <h5 className="me-2">{chartData.totalLeadCount}</h5>
                                <div className="text-success">
                                    <i className="mdi mdi-menu-up font-size-14"> </i>2.2 %
                                </div>
                            </div>
                            <p className="text-muted text-truncate mb-0">Total Leads:</p>
                        </Col>

                        <Col sm={4}>
                            <div className="mt-4 mt-sm-0">
                                <p className="mb-2 text-muted text-truncate">
                                    <i className="mdi mdi-circle text-primary font-size-10 me-1"></i> Total Add to Cart
                                </p>
                                <div className="d-inline-flex">
                                    <h5 className="mb-0 me-2">{chartData.totalAddToCartCount}</h5>
                                    <div className="text-success">
                                        <i className="mdi mdi-menu-up font-size-14"> </i>2.1 %
                                    </div>
                                </div>
                            </div>
                        </Col>

                        <Col sm={4}>
                            <div className="mt-4 mt-sm-0">
                                <p className="mb-2 text-muted text-truncate">
                                    <i className="mdi mdi-circle text-success font-size-10 me-1"></i> Total Purchases:
                                </p>
                                <div className="d-inline-flex">
                                    <h5 className="mb-0">{chartData.totalPurchaseCount}</h5>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        </React.Fragment>
    );
};

export default WebsiteAnalytics;
